import React, { useState, useEffect } from "react";
import {
  BeadCrumb,
  CustomHeader,
  NotificationModal,
  TextField,
  Button,
  FormError,
  Select,
} from "components";
// import { defaultValidation } from "utils/validators";
import { ROUTES } from "../../../routes/routePaths";
import { Formik, Form, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import {useSelector, useDispatch} from 'react-redux'
import { postRequestForTerminal } from './../../../redux/actions/terminalAction';
import {getTerminals } from './../../../redux/actions/terminalAction'
import {swapTerminalSchema} from 'validations'
// import { setAlert } from "utils/helper";

const SwapTerminal = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user, terminals } = useSelector((state) =>({
      user :state.user.user,
      terminals: state.terminalReducer.terminals
  }));

  useEffect(()=>{
    const requestParams = {
      agentId: user?.agent_id,
      status: "ENABLED"
    }
    dispatch(getTerminals(requestParams))
  },[dispatch, user?.agent_id])

  /**
   * This is to submit 
   * @param {object} values 
   * @param {object} actions 
   */
  const handleRequest = (values,actions) => {
    const data = {
      agentId: values.agentId,
      requestType:values.requestType,
      details: [
        {
          pickupLocation: values.pickupLocation,
          terminalId: values.terminalTID
        }
      ],
    }
    actions.setSubmitting(true);
    postRequestForTerminal(data).then(res=>{
      actions.setSubmitting(false);
      setShowModal(true)
    },err=>{
      actions.setSubmitting(false);
      console.log(err)
      // setAlert(res.data.responseMessage)
      if(err.response){

      }
    })
  };

    /**
   * This is an array of terminals transform to (value - label) pairs using reduce method
   * @property {array} terminals
   */
     const terminalOptions = terminals?.reduce((acc,item)=>{
      acc.push({
        value:item.terminalId,
        label:`SERIAL NUMBER - ${item.serialNumber}`
      })
      return acc
    },[])
    
  
  return (
    <div className="dashboard-containter bg-light pt-2">
      <div className="beadcrumb-margin">
        <BeadCrumb titles={["Terminals", "Request to swap Terminal"]} />
      </div>
      <CustomHeader title="Request to swap Terminal" titlePosition="center" />
      <div className="full-width-form-container">
        <Formik
          initialValues={{
            agentId:user?.agent_id || "",
            agentCode:user?.agent_code || "",
            terminalTID: "",
            requestType:2,
            pmAccount: "",
            pickupLocation: "",
          }}
          validationSchema={swapTerminalSchema}
          onSubmit={handleRequest}
        >
          {({ errors, touched, getFieldProps, isSubmitting, values }) => (
            <Form noValidate autoComplete="off">
              <div className="mb-3">
                <TextField
                  name="agentCode"
                  type="text"
                  placeholder="67-GOH"
                  label="Agent's code"
                  value={user?.agent_code}
                  disabled
                  {...getFieldProps("agentCode")}
                  hasError={errors.agentCode && touched.agentCode}
                />
                <ErrorMessage component={FormError} name="agentCode" />
              </div>

              <div className="mb-3">
                <Select
                  label="Select Terminal to be swapped"
                  placeholder="Select Terminal"
                  name="terminalTID"
                  options={terminalOptions}
                  {...getFieldProps("terminalTID")}
                  hasError={errors.terminalTID && touched.terminalTID}
                />
                <ErrorMessage component={FormError} name="terminalTID" />
              </div>
              <div>
                <TextField
                  name="pickupLocation"
                  type="text"
                  placeholder="Enter Outlet Location"
                  label="Outlet Location"
                  required={false}
                  rows="5"
                  {...getFieldProps("pickupLocation")}
                  hasError={errors.pickupLocation && touched.pickupLocation}
                />
                <ErrorMessage component={FormError} name="pickupLocation" />
              </div>

              <div className="mx-auto terminal-cta">
                <Button
                  type="submit"
                  label="Submit Request"
                  fullWidth
                  loading={isSubmitting}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <NotificationModal
        showModal={showModal}
        onClose={() => {
            setShowModal(false);
            navigate(ROUTES.terminals)
        }}
        bodyText="Your request has been sent and will be processed. You will be contacted in 3 working days on the outcome of your terminal request!"
        headerText="Request was submitted successfully!"
      />
    </div>
  );
};

export default SwapTerminal;
